import React, { useEffect, useState } from "react";
import "../Wallet/styles/addCredit.scss";
import "../TicketManagement/style.scss";
import "../NewMember/RoleManagmentAndPermission/style.scss";
import { isEmpty, isNumber } from "../../utils/common";
import { useLocation, useNavigate } from "react-router-dom";
import { addDqrDevice, addBulkDqrCard } from "../../utils/api";
import { AlertWrapper } from "../../Components/Modal/style";
import LocalLoader from "../../Components/Loader/LocalLoader";
import PictureUpload from "../../Components/PictureUpload/PictureUpload";
import dqrBulkCsv from "../../assets/file/DqrDetail.csv";

const AddDqrCard = () => {
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  const [expDate, setExpDate] = useState("");
  const [csv, setCsv] = useState("");
  const navigate = useNavigate();
  const [tab, setTab] = useState("add");

  const handleInput = (e) => {
    if (!isNumber(e.target.value) && !isEmpty(e.target.value)) return;
    setCardNumber(e.target.value);
    setErrors("");
  };
  const handleChange = (event) => {
    const { value } = event.target;
    const regex = /^[0-9/]*$/;
    if (regex.test(value)) {
      setExpDate(value);
      setErrors("");
    }
  };

  const handleSubmit = () => {
    if (tab !== "add") {
      if (isEmpty(csv?.name)) {
        setErrors("Please upload csv");
        return;
      }
      let formData = new FormData();
      formData.append("file", csv);

      addBulkDqrCard(formData).then((resp) => {
        setDisableBtn(false);
        setLoading(false);
        console.log("success", resp);
        if (resp?.data?.success) {
          setMessage({
            msg: "DQR Devices detail add successfully.",
            type: "success",
          });
          setLoading(true);
          setTimeout(() => {
            navigate("/dqr-inventory");
            setDisableBtn(false);
            setLoading(false);
          }, 2000);
        } else {
          let msg = "";
          if (resp?.data?.errorCodeList.length > 0) {
            msg = resp?.data?.errorCodeList[0];
          } else {
            msg = resp?.data?.msg;
          }
          setMessage({ msg: msg, type: "error" });
        }
      });
    } else {
      if (isEmpty(cardNumber)) {
        setErrors("Please enter 16 digit Serial Number");
        return;
      }
      if (isEmpty(expDate)) {
        setErrors("Please enter Terminal Id");
        return;
      }
      const param = {
        serialNumber: cardNumber,
        terminalId: expDate,
      };

      addDqrDevice(param).then((resp) => {
        setDisableBtn(false);
        setLoading(false);

        if (resp?.data?.success) {
          const values =  Object.values(resp?.data?.metaInfo)
          setMessage({
            msg: values[0],
            type: "success",
          });
          setLoading(true);
          setTimeout(() => {
            navigate("/dqr-inventory");
            setDisableBtn(false);
            setLoading(false);
          }, 2000);
        } else {
          let msg = "";
          if (resp?.data?.errorCodeList.length > 0) {
            msg = resp?.data?.errorCodeList[0];
          } else {
            msg = resp?.data?.msg;
          }
          setMessage({ msg: msg, type: "error" });
        }
      });
    }
  };

  useEffect(() => {
    if (isEmpty(csv?.name)) return;
    setErrors("");
  }, [csv]);

  return (
    <>
      {loading && <LocalLoader className="tableLoader" />}
      {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="subadmin_main_container">
        <div className="subadmin_head flex space-between">
          <strong>Add DQR</strong>
        </div>
        <div className="subadmin_container">
          <div className="pd-30">
            <div className="tabs flex">
              <div
                className={`tab ${tab === "add" ? "active" : ""}`}
                onClick={() => setTab("add")}
              >
                Add DQR
              </div>
              <div
                className={`tab ${tab === "bulk" ? "active" : ""}`}
                onClick={() => setTab("bulk")}
              >
                Bulk Upload
              </div>
            </div>

            <div className="flex form-container mg_top17">
              <div>
                {tab !== "add" && (
                  <lable className="filter_text fs">Card Number</lable>
                )}
                <div className="mg-top3 flex" style={{ gap: "10px" }}>
                  {tab === "add" ? (
                    <>
                      <input
                        type="text"
                        name="CardNumber"
                        value={cardNumber}
                        className="filter_select  fs"
                        placeholder="Enter Serial Number"
                        onChange={handleInput}
                       
                      />
                      <div className="flex" style={{ gap: "10px" }}>
                        <input
                          type="text"
                          name="expiryDate"
                          value={expDate}
                          className="filter_select  fs"
                          placeholder="Enter Terminal Id"
                          onChange={handleChange}
                       
                        />
                      </div>
                    </>
                  ) : (
                    <PictureUpload
                      setImage={setCsv}
                      image={csv}
                      accept=".csv"
                      type="file"
                    />
                  )}
                </div>
                {tab !== "add" && (
                  <a
                    sty
                    download={"CDM_inventory_simple.csv"}
                    href={dqrBulkCsv}
                    style={{ fontSize: "14px" }}
                  >
                    Download Simple file
                  </a>
                )}

                {!isEmpty(errors) && (
                  <p className="error fs-12 mt-10">{errors}</p>
                )}
              </div>
            </div>

            <div className="flex form-container">
              <button
                onClick={handleSubmit}
                style={{
                  width: "100%",
                  height: "45px",
                  marginTop: "25px",
                  marginBottom: "20px",
                }}
                disabled={disableBtn}
                className={
                  disableBtn
                    ? "ticket_input-field_button_disable"
                    : "userlist_btn"
                }
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddDqrCard;
